export enum CLIENT_FEATURE_REFERENCE_CODES {
	PROVIDER_DATA_SHARE = 'PDS',
	FRANCHISE = 'FCH',
	REPAYMENT = 'RPM',
	PROXY_REVIEW = 'PXY',
	BILLING = 'BIL',
	EDUCATION_PATHWAYS = 'EDP',
	NON_DEGREE = 'NDC',
	LOAN_EXPERIENCE = 'LNE',
	FAST_TRACK = 'FTE',
	PAYMENT = 'PYO',
	SITE_REDESIGN = 'SRD',
	EDUCATION_ACCESS = 'EAC',
	EDUCATION_NETWORK = 'EDN',
	WORKFORCE_EDUCATION_NETWORK = 'WEN',
	SELF_SCHEDULE_COACHING = 'SSC',
	CURRENCY_CONVERSION = 'CRC',
	MOBILE_APP = 'MAP',
	TAXES = 'TXS',
	VIRTUAL_CREDIT_CARD = 'VCC',
	JUMPSTART_PROVIDERS = 'JSP',
	CAREER_PATHWAYS = 'CRP',
	DEPENDENT_PROGRAM = 'DEP',
	SUPPRESS_DEP_PROGRAM = 'SAD',
	LOAN_REDESIGN = 'LRD',
	VERIFY_STUDENT_GRADUATION = 'VSG',
	MARKETING_JOURNEY = 'PPE',
	SHOW_STUDENT_LOAN_IN_LANDING_PAGE = 'SLP',
	SHOW_COACHING_IN_LANDING_PAGE = 'SCP'
}
